import React from "react";
import { Dimensions, Platform, ScrollView, StyleSheet, View } from "react-native";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, LottieSizeTokens, LottieTokens } from "@voltmoney/schema";
import { SCREEN_SIZE } from '@voltmoney/types';
import { Typography } from "../../typography/Typography";
import { Icon } from "../../icon/Icon";
import { Button } from "../../button/Button";
import { Divider } from "../../divider/Divider";
import { Lottie } from "../../lottie/Lottie";
const PaymentNotApproved = ({ height, date, amount, refNumber, bankName, bankAccountNumber, doneAction, triggerAction }) => {
    return (React.createElement(View, { style: [styles.container, { height: height }] },
        React.createElement(ScrollView, { style: [styles.paddingContainer, { height: Platform.OS !== "web" ? height - 350 : height - 200 }] },
            React.createElement(View, { style: styles.paymentAmountDetailsStack },
                React.createElement(Typography, { label: "Payment amount", fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Grey_Night }),
                React.createElement(View, { style: styles.paymentAmount },
                    React.createElement(Typography, { label: amount, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XXXXL, lineHeight: 40, fontWeight: "700", color: ColorTokens.Grey_Night })),
                React.createElement(View, { style: styles.paymentAmount },
                    React.createElement(Typography, { label: date, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS, lineHeight: 18, fontWeight: "200", color: ColorTokens.Grey_Charcoal }))),
            React.createElement(View, { style: styles.paymentStatusStack },
                React.createElement(View, { style: styles.paymentStatusRowStack },
                    React.createElement(View, { style: styles.paymentIcon },
                        React.createElement(Lottie, { uri: LottieTokens.Success, size: LottieSizeTokens.XS, autoplay: true, loop: false })),
                    React.createElement(Typography, { label: "Payment successful!", fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: "600", color: ColorTokens.Grey_Night })),
                React.createElement(View, { style: styles.divider }),
                React.createElement(View, { style: styles.paymentStatusRowStack },
                    React.createElement(View, { style: styles.paymentIcon },
                        React.createElement(Icon, { name: IconTokens.InProgressGrey, size: IconSizeTokens.XXL })),
                    React.createElement(View, { style: { width: '100%' } },
                        React.createElement(Typography, { label: "Updating your credit limit", fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: "600", color: ColorTokens.Grey_Charcoal }),
                        React.createElement(View, { style: styles.updateLimitDescriptionStack },
                            React.createElement(Typography, { label: "It may take 1-2 working days to update\nyour credit limit", fontWeight: "500", fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS, lineHeight: 18, color: ColorTokens.Grey_Charcoal }))))),
            React.createElement(View, { style: styles.paymentBankDetailsStack },
                React.createElement(Typography, { label: "To", fontSize: FontSizeTokens.XS, lineHeight: 18, fontWeight: "400", fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal }),
                React.createElement(View, { style: styles.marginTop4 },
                    React.createElement(Typography, { label: `${bankName} - xxxx xx${bankAccountNumber?.slice(-2)}`, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: "400", fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Night })),
                React.createElement(View, { style: styles.marginTop12 },
                    React.createElement(Typography, { label: "UPI Ref Number", fontSize: FontSizeTokens.XS, lineHeight: 18, fontWeight: "400", fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal })),
                React.createElement(View, { style: styles.marginTop4 },
                    React.createElement(Typography, { label: refNumber, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: "400", fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Night })),
                React.createElement(View, { style: styles.marginTop12 },
                    React.createElement(Typography, { label: "Date and time", fontSize: FontSizeTokens.XS, lineHeight: 18, fontWeight: "400", fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal })),
                React.createElement(View, { style: styles.marginTop4 },
                    React.createElement(Typography, { label: date, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: "400", fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Night })))),
        React.createElement(View, { style: styles.bottomContainer },
            React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }),
            React.createElement(View, { style: { padding: 16 } },
                React.createElement(Button, { onPress: () => {
                        if (doneAction) {
                            triggerAction({
                                ...doneAction
                            });
                        }
                    }, type: ButtonTypeTokens.LargeFilled, label: "Done", fontSize: FontSizeTokens.SM, width: ButtonWidthTypeToken.FULL })))));
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
const styles = StyleSheet.create({
    container: {
        marginHorizontal: -16,
        marginTop: Platform.OS === 'ios' ? 16 : -16
    },
    paddingContainer: {
        paddingVertical: 24,
        paddingHorizontal: 16,
        paddingBottom: 40,
    },
    paymentAmount: {
        marginTop: 9,
    },
    paymentAmountDetailsStack: {
        justifyContent: 'center',
        alignSelf: 'center',
        alignContent: 'center',
        alignItems: 'center'
    },
    paymentStatusStack: {
        height: 169,
        borderWidth: 1,
        borderRadius: 16,
        borderColor: "#E4E7EC",
        padding: 16,
        marginTop: 16
    },
    paymentStatusRowStack: {
        flexDirection: 'row'
    },
    paymentIcon: {
        marginRight: 12
    },
    divider: {
        borderStyle: 'dashed',
        height: 29,
        borderWidth: 1,
        borderColor: "#E4E7EC",
        width: 1,
        marginLeft: 11,
        marginTop: 2,
        marginBottom: 2
    },
    updateLimitDescriptionStack: {
        borderRadius: 6,
        borderWidth: 1,
        height: 56,
        backgroundColor: "#F1F3F5",
        padding: 10,
        marginTop: 8,
        borderColor: "#F1F3F5",
        width: "90%"
    },
    paymentBankDetailsStack: {
        height: 182,
        padding: 16,
        borderColor: "#E4E7EC",
        backgroundColor: "#F9FAFB",
        marginTop: 16,
        borderRadius: 12,
        marginBottom: 54
    },
    marginTop4: {
        marginTop: 4
    },
    marginTop12: {
        marginTop: 12
    },
    bottomContainer: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
    }
});
export default (PaymentNotApproved);
